import type { TemplateField } from '@/modules/template';

/**
 * News-specific fields an author could inject into the share form. Empty for
 * now — the news form's fields are authored inline in the news YAML. The seam
 * is here for surfacing type-specific insertable fields later.
 */
export const newsInjectableFields: readonly TemplateField[] = [];
